"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchUsersByQuery = exports.updateUserByExternalId = exports.getFileSlugLink = exports.uploadFile = void 0;
/* eslint-disable no-useless-catch */
/* istanbul ignore file */
var quickblox_flash_1 = __importDefault(require("@flash-chat/quickblox-flash"));
var getUserFromQBData_1 = require("./users/getUserFromQBData");
var getConfig = function () {
    var service = quickblox_flash_1.default.service;
    var _a = service.qbInst, config = _a.config, session = _a.session;
    // @ts-expect-error qb types sucks
    var token = session.token;
    var api = config.endpoints.api;
    return { api: api, token: token };
};
exports.uploadFile = function (file) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, api, token, formData, res, data, error_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                _a = getConfig(), api = _a.api, token = _a.token;
                formData = new FormData();
                formData.append('file', file);
                return [4 /*yield*/, fetch("https://" + api + "/files/upload.json", {
                        method: 'POST',
                        headers: {
                            'QB-Token': token,
                        },
                        body: formData,
                    })];
            case 1:
                res = _b.sent();
                if (!res.ok)
                    return [2 /*return*/, {}];
                return [4 /*yield*/, res.json()];
            case 2:
                data = _b.sent();
                return [2 /*return*/, data];
            case 3:
                error_1 = _b.sent();
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getFileSlugLink = function (attacment) {
    var serviceId = attacment.serviceId, uuid = attacment.uuid, token = attacment.token, expires = attacment.expires;
    return "/" + serviceId + "-" + uuid + "?token=" + token + "&expires=" + expires;
};
exports.updateUserByExternalId = function (_a) {
    var externalId = _a.externalId, data = _a.data, authToken = _a.authToken, applicationId = _a.applicationId;
    return __awaiter(void 0, void 0, void 0, function () {
        var api, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    api = getConfig().api;
                    return [4 /*yield*/, fetch("https://" + api + "/user/users/" + externalId + ".json", {
                            method: 'PUT',
                            headers: {
                                'x-flash-application-id': applicationId,
                                Authorization: authToken,
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify(data),
                        })];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _b.sent();
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    });
};
exports.searchUsersByQuery = function (_a) {
    var searchQuery = _a.searchQuery, applicationId = _a.applicationId;
    return __awaiter(void 0, void 0, void 0, function () {
        var api, res, list, users, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    api = getConfig().api;
                    return [4 /*yield*/, fetch("https://" + api + "/user/search.json?search=" + encodeURIComponent(searchQuery), {
                            headers: {
                                'x-flash-application-id': applicationId,
                            },
                        })];
                case 1:
                    res = _b.sent();
                    return [4 /*yield*/, res.json()];
                case 2:
                    list = (_b.sent()).list;
                    users = list.map(function (user) { return getUserFromQBData_1.getUserFromQBData(user); });
                    return [2 /*return*/, users];
                case 3:
                    error_3 = _b.sent();
                    throw error_3;
                case 4: return [2 /*return*/];
            }
        });
    });
};
//# sourceMappingURL=chatNgAdapter.js.map